import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { Link, useLocation } from "react-router";
import Button from "@mui/material/Button";
import React from "react";
import ErrorSubmitDataAlert from "../../../../components/Alert/ErrorSubmitDataAlert";
import LoadingDataAlert from "../../../../components/Alert/LoadingDataAlert";
import SuccessSubmitDataAlert from "../../../../components/Alert/SuccessSubmitDataAlert";
import PaperDialog from "../../../../components/Dialog/PaperDialog";
import { useData } from "../../../../lib/context/DataContext";
export default function SupprimerVente() {
	const id = useLocation().pathname.split("/")[4];

	const [status, setStatus] = React.useState(null);

	const { fetchDataVentes, fetchDataCommandes } = useData();

	const submitDelete = async () => {
		try {
			const res = await fetch("/api/deleteVente", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(id),
			});

			if (res.ok) {
				setStatus("success");
			} else {
				//const json = await res.json();
				//setErrorMessage(json.error || "Erreur inconnue");
				setStatus("error");
			}
		} catch (err) {
			//setErrorMessage(err.message || "Erreur réseau");
			setStatus("error");
		} finally {
			await fetchDataVentes();
			await fetchDataCommandes();
		}
	};

	return (
		<PaperDialog
			titre={"Supprimer une vente"}
			actions={
				<>
					<Link to="..">
						<Button
							color="error"
							variant="contained"
						>
							{!status ? "Annuler" : "Fermer"}
						</Button>
					</Link>
					{!status && (
						<Button
							color="success"
							variant="contained"
							onClick={() => submitDelete()}
						>
							Valider
						</Button>
					)}
				</>
			}
		>
			{status === "error" && (
				<ErrorSubmitDataAlert>
					Une erreur est survenue lors de la suppression de la
					<b>{" " + id}</b>
				</ErrorSubmitDataAlert>
			)}
			{status === "loading" && <LoadingDataAlert />}
			{status === "success" && (
				<SuccessSubmitDataAlert>
					la
					<b>{" " + id}</b> a bien été supprimé
				</SuccessSubmitDataAlert>
			)}
			{!status && (
				<Alert
					severity="error"
					sx={{
						"& .MuiAlert-icon": {
							fontSize: 40,
						},
					}}
				>
					<AlertTitle variant="h4">Attention</AlertTitle>
					Etes-vous sûr de vouloir supprimmer la
					<b>{" " + id}</b>
				</Alert>
			)}
		</PaperDialog>
	);
}
